import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 20l14 -8l-14 -8z","key":"svg-0"}],["path",{"d":"M19 20l-14 -8l14 -8z","key":"svg-1"}]]

const IconBrandBackbone = createReactComponent('outline', 'brand-backbone', 'BrandBackbone', __iconNode);

export default IconBrandBackbone;